import gql from 'graphql-tag';

export const JobMatchesById = gql`
	query QueryJobMatchesByJobIdIndex($jobId: ID!, $first: Int, $after: String) {
		queryJobMatchesByJobIdIndex(jobId: $jobId, first: $first, after: $after) {
			items {
				id
				contactId
				jobId
				dateCreated
				relevance
				matchStatus
				userId
			}
			nextToken
		}
	}
`;